import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

// Iter 123 — `?lang=xx` sur une navigation SPA (login/register/forgot/reset) : appliqué comme
// langue de lien (session), sans jamais écraser un choix manuel de l'utilisateur.
export const useLinkLanguage = () => {
  const { applyLinkLanguage } = useLanguage();
  const { search } = useLocation();
  useEffect(() => {
    const lang = new URLSearchParams(search).get('lang');
    if (lang) applyLinkLanguage(lang);
  }, [search, applyLinkLanguage]);
};

export default useLinkLanguage;
